/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2021-03-23T16:04:05.435
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	listChannelpic,
	listChannelpicInit,
	listChannelpicByAuthorizations,
	deleteChannelpic
	
} from '@api/rentmanage/Channelpic';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {	
		// 初始化信息
		CompoundEntitiesDictionary: cloneObj(RespCommonDef.CompoundEntitiesDictionary),
		//查询接口返回的数据
		CompoundEntities: cloneObj(RespCommonDef.CompoundEntities),
	    Entities:cloneObj(RespCommonDef.Entities),
		//查询条件
		AdvanceQuery:cloneObj(RespCommonDef.AdvanceQuery),
	},

	actions: {
		listChannelpic({
			state
		}) {
			return new Promise((resolve, reject) => {
				listChannelpic(state.AdvanceQuery)
					.then(async res => {
						state.Entities = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listChannelpicByAuthorizations({
			state
		}) {
			return new Promise((resolve, reject) => {
				listChannelpicByAuthorizations(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntities =res
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listChannelpicInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				listChannelpicInit(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntitiesDictionary = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteChannelpic({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteChannelpic({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

	}
};
